import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUIColorFont } from "../User/State/UIElement/Action";

const useUIStyles = () => {
  const dispatch = useDispatch();
  const { publicUIColorFonts } = useSelector((store) => store);
  
   useEffect(() => {
     dispatch(getAllUIColorFont());
    }, [dispatch]);

  const getStyle = (type) => {
    const styleObj = publicUIColorFonts?.uiColorFonts?.response?.find((item) => item.type === type);
    return {
      color: styleObj?.colorCode || "#000000",
      fontSize: styleObj?.fontSize || "16px",
      fontFamily: styleObj?.fontFamily || "Arial",
    };
  };

  return {
    heading: getStyle("heading"),
    title: getStyle("title"),
    description: getStyle("description"),
  };
};

export default useUIStyles;
